<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0.5 0.5 20 20"
    aria-hidden="true"
    focusable="false"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M1.5 5.5L3.5 3.5H5V17.5H2.5V7H1.5Z" />
      <path
        d="M18 8C17.1 5.3 15.2 3.5 13 3.5C9.7 3.5 7 6.6 7 10.5S9.7 17.5 13 17.5H19.5V14.5H13C11.1 14.5 9.5 12.7 9.5 10.5S11.1 6.5 13 6.5C14 6.5 14.9 7.1 15.5 8Z"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
